module.exports = __webpack_public_path__ + "img/bg_checkbox.fba52bee.svg";